import {
  Line,
  LineChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { palette } from "./palettes";
import { useTheme } from "@/components/theme-provider";

export interface VroomLineChartProps<T extends object> {
  data: T[];
  xKey: keyof T & string;
  series: { key: keyof T & string; label: string }[];
  height?: number;
}

export function VroomLineChart<T extends object>({
  data,
  xKey,
  series,
  height = 240,
}: VroomLineChartProps<T>) {
  const { resolvedTheme } = useTheme();
  const colors = palette.cat();
  const axis = palette.axis();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} key={resolvedTheme}>
        <CartesianGrid stroke={axis.grid} strokeDasharray="2 3" vertical={false} />
        <XAxis
          dataKey={xKey as never}
          stroke={axis.stroke}
          tick={{ fill: axis.text, fontSize: 11 }}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke={axis.stroke}
          tick={{ fill: axis.text, fontSize: 10.5 }}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip
          contentStyle={{
            background: "var(--surface)",
            border: "1px solid var(--line)",
            borderRadius: 5,
            fontSize: 12,
          }}
        />
        {series.map((s, i) => (
          <Line
            key={s.key}
            dataKey={s.key as never}
            stroke={colors[i % colors.length]}
            strokeWidth={1.5}
            dot={false}
            name={s.label}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
